import { SelectProps } from "antd";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { useState } from "react";
import SelectBaseAntd from "../SelectBaseAntd";
import useAreasComumSimples from "../../../../core/features/area-comum/hooks/useAreasComumSimples";

export interface SelectAreaComumProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any, option?: any) => void;
  isInvalid?: boolean;
  filterIds?: string[];
}

function SelectAreaComum({
  value,
  onChange,
  isInvalid,
  filterIds = [],
  ...rest
}: SelectAreaComumProps) {
  const { tenant } = useCurrentTenant();
  const [search, setSearch] = useState<string | undefined>();
  const { isLoading, data } = useAreasComumSimples(tenant.id);

  const _options = data?.filter((item) => !filterIds.includes(item.id));

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      loading={isLoading}
      size="large"
      placeholder="Selecione o espaço"
      value={value || undefined}
      onChange={onChange}
      searchValue={search}
      onSearch={setSearch}
      {...rest}
      showSearch
      allowClear
      optionFilterProp="label"
      options={_options?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectAreaComum;
